var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.796,
    height: 42.006,
    viewBox: "0 0 45.796 42.006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "dashboard",
    d: "M45.6,20.928A22.894,22.894,0,0,0,0,23.91,22.661,22.661,0,0,0,7.172,40.531a9.234,9.234,0,0,0,6.4,2.457H32.2A9.528,9.528,0,0,0,38.9,40.262a22.787,22.787,0,0,0,6.7-19.334Zm-9.365,16.6A5.723,5.723,0,0,1,32.2,39.172H13.57a5.46,5.46,0,0,1-3.779-1.414A18.887,18.887,0,0,1,3.816,23.91,19.1,19.1,0,0,1,10.184,9.683,18.851,18.851,0,0,1,22.867,4.832a20.133,20.133,0,0,1,2.24.126A19.067,19.067,0,0,1,36.231,37.535ZM14.894,32.085a1.909,1.909,0,0,1-2.671,2.728A15.264,15.264,0,0,1,25.075,8.8a1.908,1.908,0,0,1,1.616,2.162,1.887,1.887,0,0,1-2.162,1.618,11.447,11.447,0,0,0-9.634,19.5ZM38,21.729a15.4,15.4,0,0,1,.155,2.181,15.131,15.131,0,0,1-4.594,10.905,1.91,1.91,0,0,1-2.671-2.732,11.409,11.409,0,0,0,3.327-9.808A1.909,1.909,0,1,1,38,21.729Zm-11.434,1.2a3.879,3.879,0,1,1-2.7-2.7l7.213-7.213a1.908,1.908,0,1,1,2.7,2.7Z",
    transform: "translate(0 -0.982)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.1139ca2c8d52dbf14fd0b41180df1998.svg";
export { ForwardRef as ReactComponent };